// @flow

import React from 'react';
import styled from 'styled-components';
import { ifProp, prop } from 'styled-tools';

type Props = {
  children?: any,
  maxWidth?: string,
  noPadding?: boolean,
};

const Wrapper = styled.div`
  width: 100%;
  max-width: ${prop('maxWidth', '1440px')};
  padding: ${ifProp('noPadding', '0', '0 20px')};
  margin: 0 auto;
  box-sizing: border-box;
`;

const WidthContainer = (props: Props) => (
  <Wrapper maxWidth={props.maxWidth} noPadding={props.noPadding}>
    {props.children}
  </Wrapper>
);

export default WidthContainer;



// WEBPACK FOOTER //
// ./src/components/WidthContainer/index.js